import LectureScheduledIcon from "Assets/Icons/LectureScheduledIcon";
import UnmarkedLectureIcon from "Assets/Icons/UnmarkedLecture";
import { Avatar } from "antd";
import { Badge } from "antd";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { capitalizeFirstCharaterOfString } from "utilFunctions/helperFunctions/utilFunctions";

const StyledSpan1 = styled<any>("span")`
  color: var(--Grey-80, #333);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
`;
const StyledSpan2 = styled<any>("span")`
  color: var(--Grey-50, #afafaf);
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  padding-left: 8px;
`;
const StyledDiv = styled<any>("div")`
  color: var(--Grey-60, #757575);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */
`;
interface NotificationBoxIF {
  imageUrl: string;
  primaryMessage: string;
  message: string;
  date: any;
}
const NotificationBox = ({
  imageUrl,
  primaryMessage,
  message,
  date,
}: NotificationBoxIF) => {
  const navigate = useNavigate();
  const returnDaysAndTime = (givenTimestamp: any) => {
    const currentTimestamp = Date.now();
    const differenceInMilliseconds = currentTimestamp - givenTimestamp;

    const millisecondsInAMinute = 1000 * 60;
    const millisecondsInAnHour = millisecondsInAMinute * 60;
    const millisecondsInADay = millisecondsInAnHour * 24;

    const days = Math.floor(differenceInMilliseconds / millisecondsInADay);
    const hours = Math.floor(
      (differenceInMilliseconds % millisecondsInADay) / millisecondsInAnHour
    );
    const minutes = Math.floor(
      (differenceInMilliseconds % millisecondsInAnHour) / millisecondsInAMinute
    );

    if (days > 0) {
      return `${days} days ago`;
    } else if (hours > 0) {
      return `${hours} hrs ago`;
    } else if (minutes > 0) {
      return `${minutes} mins ago`;
    } else {
      return "Just now";
    }
  };
  return (
    <div
      className="d-flex flex-row gap-2"
      style={{
        width: "100%",
      }}
    >
      <div
        style={{
          marginTop: "5px",
          width: "36px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {primaryMessage == "Lecture scheduled" ? (
          <LectureScheduledIcon />
        ) : primaryMessage == "Unmarked lecture" ? (
          <UnmarkedLectureIcon />
        ) : (
          <Avatar
            style={{
              verticalAlign: "middle",
            }}
            size="small"
            gap={12}
            src={imageUrl ? imageUrl : ""}
          >
            {capitalizeFirstCharaterOfString(primaryMessage)}
          </Avatar>
        )}
      </div>
      <div
        className="d-flex flex-column w-100 cursor-pointer"
        onClick={() => {
          if (
            ["Lecture scheduled", "Unmarked lecture"].includes(primaryMessage)
          ) {
            navigate("/admin/schedule", { state: null });
          }
        }}
      >
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="d-flex align-items-center">
            <StyledSpan1>{primaryMessage}</StyledSpan1>
            <StyledSpan2>{returnDaysAndTime(date)}</StyledSpan2>
          </div>
          <Badge color="geekblue" />
        </div>
        <StyledDiv>{message}</StyledDiv>
      </div>
    </div>
  );
};

export default NotificationBox;
